const env = import.meta.env;

export const config = {
  // Required, from .env (checked by each app's vite.config.ts and startApp).
  graphqlUrl: env.VITE_GRAPHQL_API ?? '',
  keycloakUrl: env.VITE_KEYCLOAK_URL ?? 'https://auth.daftaron.com',
  keycloakRealm: env.VITE_KEYCLOAK_REALM ?? 'daftaron',
  keycloakClientId: env.VITE_KEYCLOAK_CLIENT_ID ?? 'frontend',
  // Local development against arqam with DANGEROUSLY_DISABLE_AUTH=true.
  authDisabled: env.VITE_AUTH_DISABLED === 'true',
  // With auth disabled: the roles to pretend to have (e.g. "committee" to see
  // the read-only screens). Default: every role.
  authDisabledRoles: (env.VITE_AUTH_DISABLED_ROLES ?? '')
    .split(',')
    .map((r: string) => r.trim())
    .filter(Boolean),
  // Roles are not in the tokens yet; turn this on once arqam deploys them.
  enforceRoles: env.VITE_ENFORCE_ROLES === 'true',
};
